'use client';

import Image from 'next/image';

import { ReviewForm } from '@/widgets/me-reviews/review-form';

import type { IMasterclass } from '@/entities/masterclass/types';

type ReviewFormShellProps = {
  masterclass: IMasterclass;
  /** меньше отступы внутри bottom sheet */
  variant?: 'page' | 'drawer';
};

export const ReviewFormShell = ({
  masterclass,
  variant = 'page',
}: ReviewFormShellProps) => {
  const gapClass = variant === 'drawer' ? 'gap-4' : 'gap-5';
  const titleClass = variant === 'drawer' ? 'text-base' : 'text-lg';

  return (
    <>
      <div className={`flex flex-col ${gapClass} items-center w-full`}>
        <div className="flex gap-4 relative overflow-hidden">
          {masterclass.images?.[0]?.url && (
            <div className="w-[220px] h-[220px] rounded-full shrink-0">
              <Image
                className="w-[220px] h-[220px] rounded-full object-cover shadow"
                src={masterclass.images[0].url}
                alt={masterclass.name}
                width={200}
                height={200}
              />
            </div>
          )}
          <div className="flex flex-col gap-4">
            {masterclass.images?.[1]?.url && (
              <div className="w-[100px] h-[100px] ml-8 rounded-full">
                <Image
                  className="w-[100px] h-[100px] rounded-full object-cover shadow"
                  src={masterclass.images[1].url}
                  alt={masterclass.name}
                  width={100}
                  height={100}
                />
              </div>
            )}
            {masterclass.images?.[2]?.url && (
              <div className="w-[100px] h-[100px] rounded-full">
                <Image
                  className="w-[100px] h-[100px] rounded-full object-cover shadow"
                  src={masterclass.images[2].url}
                  alt={masterclass.name}
                  width={100}
                  height={100}
                />
              </div>
            )}
          </div>
        </div>

        <div className={`${titleClass} text-center px-2`}>
          Отзыв на МК «{masterclass.name}»
        </div>
      </div>
      <ReviewForm
        masterclassId={masterclass.id}
        masterclassWordId={masterclass.wordId}
        afterSubmitSuccess={variant === 'drawer' ? 'back' : 'push'}
      />
    </>
  );
};
